import { render, staticRenderFns } from "./grupaNDA.vue?vue&type=template&id=347ea632&scoped=true&"
import script from "./grupaNDA.vue?vue&type=script&lang=js&"
export * from "./grupaNDA.vue?vue&type=script&lang=js&"
import style0 from "./grupaNDA.vue?vue&type=style&index=0&id=347ea632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347ea632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347ea632')) {
      api.createRecord('347ea632', component.options)
    } else {
      api.reload('347ea632', component.options)
    }
    module.hot.accept("./grupaNDA.vue?vue&type=template&id=347ea632&scoped=true&", function () {
      api.rerender('347ea632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/grupaNDA.vue"
export default component.exports